import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Button, Col } from 'react-bootstrap';
import { Icon, SearchInput } from '../../widgets';
import { setLoadQueueSortOrder } from '../../../actions/load';
import LoadQueueFilter from './LoadQueueFilter';
import AddLoadForm from '../../seedHistory/AddLoadForm';
import { getDateRangeInfo } from '../../../actions/analyze';
import { isToday, usePermission } from '../../../helpers/common';
import { getSeedHistory, getSeedTareLoad } from '../../../actions/plan';
import { ScaleSocket } from '../Scale/SclaeSocket';
import { getLoadParamsByPlanTypeId } from '../../../constants/load-headers';
import BulkLoadPreview from '../../LoadHistory/BulkLoadPreview';
import { getScaleMachineDetails } from '../../../helpers/session';

const LoadQueueFilterSection = props => {
	const params = useParams();
	const dispatch = useDispatch();
	const { searchText, onSearch, selectedLoadIds, handleMultiApprove, isPlanterAllocation, isApproving } = props;
	const { custom, range } = useSelector(state => state.analyze.searchParams);
	const loadQueueType = useSelector(state => state.load.loadQueueType);
	const farmSettings = useSelector(state => state.farm.farmSettings.farm_config);
	const farmSettingsAll = useSelector(state => state.farm.farmSettings);
	const scaleSocket = useSelector(state => state.scaleSocket);
	const loadList = useSelector(state => state.load.loadQueueList.data);
	const scaleDevice = getScaleMachineDetails();

	const { type } = params;

	const [oldestFirst, setOldestFiest] = useState(false);
	const [isAddLoad, setIsAddLoad] = useState(false);
	const planTypeId = useSelector(state => state.plan.selectedPlanType);
	const isCompleted = useSelector(state => state.load.isComplete);
	const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
	const crewId = useSelector(state => state.crew);
	const egId = useSelector(state => state.analyze.analyzeParams.egId);
	const isTruck = useSelector(state => state.analyze.analyzeParams.isTruck);

	const { remote_scale_socket = {} } = farmSettings || {};
	const isRemoteScaleEnable = (remote_scale_socket && remote_scale_socket.visible);

	const { socketConneted } = useMemo(() => {
		const { isConnected } = scaleSocket;
		return { socketConneted: isConnected }
	}, [scaleSocket]);

	const [previewData, setPreviewData] = useState({ allColumns: [], loadTicketEnabled: false });
	const [showPreview, setShowPreview] = useState(false);

	useEffect(() => {
		const { allColumns, loadTicketEnabled } = getLoadParamsByPlanTypeId(planTypeId, farmSettings, true, farmSettingsAll);
		setPreviewData({ allColumns, loadTicketEnabled });
	}, [farmSettings]);

	const { previewFormData, showTicketPrint } = useMemo(() => {
		return {
			previewFormData: previewData.allColumns,
			showTicketPrint: previewData.loadTicketEnabled
		}
	}, [previewData]);

	const allow = usePermission();

	const getSeedHistoryList = () => {
		if (farmId) {
			const paramsObj = {
				farm_uuid: farmId,
				range_type: range,
				from_date: custom.from,
				to_date: custom.to,
				plan_type_id: 2,
				include_events: true,
			};

			if (type === 'crew' && crewId) paramsObj['crew_uuid'] = crewId
			if (isTruck === 'false' && egId) paramsObj['target_equipment_group_uuid'] = egId;
			if (isTruck === 'true' && egId) paramsObj['source_equipment_group_uuid'] = egId;

			dispatch(getSeedHistory(paramsObj));
		}
	}

	const getSeedTareHistory = () => {
		const dateInfo = dispatch(getDateRangeInfo());
		const loadParams = {
			farm_uuid: farmId,
			egId: egId ? egId : null,
			include_events: true,
			range_type: dateInfo.range,
			from_date: dateInfo.fromDate,
			to_date: dateInfo.toDate,
			is_tareload: true,
			crew_uuid: crewId
		};
		dispatch(getSeedTareLoad(loadParams));
	};

	// const isMarkAsComplete = useMemo(() => {
	//     if (selectedLoadIds && selectedLoadIds.length > 0) {
	//         if (isNeedPlanterValues) return false;
	//         return true;
	//     }
	//     return true;
	// }, [isNeedPlanterValues, selectedLoadIds])

	const getButtonLabel = useMemo(() => {
		if (isPlanterAllocation) return isCompleted ? "Completing..." : "Mark as Complete";
		return isApproving ? "Approving..." : "Approve";
	}, [isCompleted, isPlanterAllocation, isApproving]);

	const hidePreview = () => {
		setShowPreview(false);
	};

	const selectedLoadList = useMemo(() => {
		if (selectedLoadIds && selectedLoadIds.length > 0) {
			return loadList.filter(load => selectedLoadIds.includes(load.loadActivityId));
		}
		return [];
	}, [loadList, selectedLoadIds])

	return <>
		<Col lg={12} md={12} sm={12} xs={12} className="p-0 m-0">
			<div className="d-flex filter-section">
				<LoadQueueFilter />
				<div className="sort-dropdown-container mx-0">
					<button
						title="Newest First"
						disabled={!oldestFirst}
						onClick={() => {
							dispatch(setLoadQueueSortOrder(parseInt(2)));
							setOldestFiest(false)
						}} >
						<i className="fa fa-arrow-up" />
					</button>
					<button
						title="Oldest First"
						disabled={oldestFirst}
						onClick={() => {
							dispatch(setLoadQueueSortOrder(parseInt(1)));
							setOldestFiest(true)
						}} >
						<i className="fa fa-arrow-down" />
					</button>
				</div>
				<div className={`input-search-div ${(socketConneted && loadQueueType === 1) ? 'input-search-div-updated planting' : ''}`}>
					<SearchInput
						initialValue={searchText}
						onChange={onSearch}
						placeholder="Search for Crew, EG" />
				</div>
				{(loadQueueType === 1 && isRemoteScaleEnable && scaleDevice && scaleDevice.scaleDeviceId) ? <ScaleSocket scaleDevice={scaleDevice} /> : null}
				{loadQueueType === 1 && !socketConneted &&
					<Col className='mt-1'>
						<Button
							size="sm"
							title={getButtonLabel}
							className="btn-load-queue float-right"
							disabled={(selectedLoadIds && selectedLoadIds.length === 0)}
							// disabled={isMarkAsComplete}
							variant='success'
							style={{ fontSize: '0.75rem' }}
							onClick={handleMultiApprove}
						>
							{getButtonLabel}
						</Button>
					</Col>}
				{(selectedLoadIds && selectedLoadIds.length === 0) && (isToday(range) && planTypeId && planTypeId === 2 && allow("load-history", "create")) && loadQueueType === 1 && <div className='add-load-btn ml-auto pr-2'>
					<Button
						size="sm"
						variant='btn-default'
						title='Add Load'
						className="btn-load-queue mt-2 float-right btn-sm p-0"
						onClick={() => setIsAddLoad(true)}>
						<i className="fa fa-plus-circle" style={{ fontSize: '20px' }} />
					</Button>
				</div>}

				{showTicketPrint && (selectedLoadIds && selectedLoadIds.length > 0) && (
					<div className="mx-1 load_queue_print">
						<Icon
							className="fa fa-print cursor-pointer"
							onClick={() => setShowPreview(true)}
						/>
					</div>
				)}

				<AddLoadForm
					farmId={farmId}
					show={isAddLoad}
					setShowAddLoad={setIsAddLoad}
					isCloned={false}
					load={null}
					getSeedHistoryList={getSeedHistoryList}
					getSeedTareHistory={getSeedTareHistory}
					selectedViewType={1}
					onHide={() => setIsAddLoad(false)}
					isQueue={true}
				/>
				{showPreview ? <BulkLoadPreview show={showPreview} onHide={hidePreview} loadList={selectedLoadList}
					previewFormData={previewFormData} /> : null}
			</div>
		</Col>
	</>
}


export default LoadQueueFilterSection;